import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';

interface IDeactivatedUserSupportParams {
    user_email: string;
}

const sendDeactivatedUserSupport = async (params: IDeactivatedUserSupportParams): Promise<{ message: string }> => {
    const response = await axiosInstance.post(
        API_ENDPOINTS.SIGNUP.DEACTIVATED_USER_SUPPORT,
        null,
        {
            params,
        },
    );
    return response.data;
};

export const useDeactivatedUserSupport = () => useMutation<{ message: string }, Error, IDeactivatedUserSupportParams>({
    mutationFn: sendDeactivatedUserSupport,
});

export default useDeactivatedUserSupport;
